import { db } from "@/utils/firebase";
import { query, orderBy, collection, getDocs } from "firebase/firestore";

const getArchived = async () => {
  try {
    // References to the collections
    const buyerRequestsRef = collection(db, "archived_buyer_requests");
    const sellerRequestsRef = collection(db, "archived_seller_requests");

    // Queries for both buyer and seller requests
    const buyerQuery = query(buyerRequestsRef, orderBy("created_at", "desc"));
    const sellerQuery = query(sellerRequestsRef, orderBy("created_at", "desc"));

    // Fetch the documents for both collections
    const [buyerSnapshot, sellerSnapshot] = await Promise.all([
      getDocs(buyerQuery),
      getDocs(sellerQuery),
    ]);

    // Process the documents from buyer_requests
    const buyerRequests = buyerSnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        ...data,
        created_at: data.created_at.toDate().toISOString(),
        type: "archived_buyer_request", // Add a type field to differentiate
      };
    });

    // Process the documents from seller_requests
    const sellerRequests = sellerSnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        ...data,
        created_at: data.created_at.toDate().toISOString(),
        type: "archived_seller_request", // Add a type field to differentiate
      };
    });

    // Combine and sort the requests by created_at in descending order
    const allRequests = [...buyerRequests, ...sellerRequests].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );

    return allRequests;
  } catch (error) {
    console.error("Error fetching all requests:", error);
    throw new Error("Failed to fetch all requests");
  }
};

export default getArchived;
